import styled from "styled-components";
import { Mixins } from "../theme";
import Card from "./Card";
import Link from "./Link";
export var Page = styled.div.withConfig({
  displayName: "SharedStyledComponents__Page",
  componentId: "sc-1cr9zfr-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;margin:0 auto;"]);
export var Divider = styled.div.withConfig({
  displayName: "SharedStyledComponents__Divider",
  componentId: "sc-1cr9zfr-1"
})(["margin-bottom:4rem;margin-top:4rem;width:10%;height:0.25rem;background-color:", ";"], function (props) {
  return props.theme.colors.homeDivider;
});
export var CenterDivider = styled.div.withConfig({
  displayName: "SharedStyledComponents__CenterDivider",
  componentId: "sc-1cr9zfr-2"
})(["margin-bottom:4rem;margin-top:4rem;height:0.25rem;width:10%;display:flex;justify-content:center;background-color:", ";"], function (props) {
  return props.theme.colors.homeDivider;
});
export var Content = styled.div.withConfig({
  displayName: "SharedStyledComponents__Content",
  componentId: "sc-1cr9zfr-3"
})(["padding:1rem 2rem;width:100%;"]);
export var TwoColumnContent = styled(Content).withConfig({
  displayName: "SharedStyledComponents__TwoColumnContent",
  componentId: "sc-1cr9zfr-4"
})(["display:flex;justify-content:space-between;padding:2rem;margin-bottom:3rem;@media (max-width:", "){flex-direction:column;}"], function (props) {
  return props.theme.breakpoints.l;
});
export var LeftColumn = styled.div.withConfig({
  displayName: "SharedStyledComponents__LeftColumn",
  componentId: "sc-1cr9zfr-5"
})(["flex:0 0 50%;max-width:75%;margin-right:4rem;@media (max-width:", "){max-width:100%;margin-right:0;}"], function (props) {
  return props.theme.breakpoints.l;
});
export var RightColumn = styled(LeftColumn).withConfig({
  displayName: "SharedStyledComponents__RightColumn",
  componentId: "sc-1cr9zfr-6"
})(["margin-right:0;flex:0 1 50%;display:flex;flex-direction:column;justify-content:center;@media (max-width:", "){margin-top:3rem;}"], function (props) {
  return props.theme.breakpoints.l;
});
export var Intro = styled.div.withConfig({
  displayName: "SharedStyledComponents__Intro",
  componentId: "sc-1cr9zfr-7"
})(["max-width:608px;margin-bottom:4rem;@media (max-width:", "){margin-bottom:3rem;}"], function (props) {
  return props.theme.breakpoints.s;
});
export var GrayContainer = styled.div.withConfig({
  displayName: "SharedStyledComponents__GrayContainer",
  componentId: "sc-1cr9zfr-8"
})(["width:100%;padding:4rem 0rem;margin-top:2rem;background:", ";box-shadow:inset 0px 1px 0px ", ";"], function (props) {
  return props.theme.colors.grayBackground;
}, function (props) {
  return props.theme.colors.tableItemBoxShadow;
});
export var GradientContainer = styled.div.withConfig({
  displayName: "SharedStyledComponents__GradientContainer",
  componentId: "sc-1cr9zfr-9"
})(["width:100%;padding:4rem 0rem;margin-top:2rem;background:", ";box-shadow:inset 0px 1px 0px ", ";"], function (props) {
  return props.theme.colors.cardGradient;
}, function (props) {
  return props.theme.colors.tableItemBoxShadow;
});
export var SloganGradient = styled.div.withConfig({
  displayName: "SharedStyledComponents__SloganGradient",
  componentId: "sc-1cr9zfr-10"
})(["font-weight:800;font-size:48px;line-height:140%;max-width:720px;margin-top:1rem;background-clip:text;background-image:", ";-webkit-background-clip:text;-webkit-text-fill-color:transparent;margin-bottom:0rem;@media (max-width:", "){font-size:40px;}"], function (props) {
  return props.theme.colors.eth2Gradient;
}, function (props) {
  return props.theme.breakpoints.l;
});
export var NavLink = styled(Link).withConfig({
  displayName: "SharedStyledComponents__NavLink",
  componentId: "sc-1cr9zfr-11"
})(["text-decoration:none;margin-right:2rem;color:", ";svg{fill:", ";}&:hover{color:", ";svg{fill:", ";}}&.active{font-weight:bold;}"], function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.text200;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
export var FakeLink = styled.div.withConfig({
  displayName: "SharedStyledComponents__FakeLink",
  componentId: "sc-1cr9zfr-12"
})(["color:", ";cursor:pointer;"], function (props) {
  return props.theme.colors.primary;
}); // Avoid DOM error for nested links

export var FakeLinkExternal = styled.div.withConfig({
  displayName: "SharedStyledComponents__FakeLinkExternal",
  componentId: "sc-1cr9zfr-13"
})(["color:", ";&:after{margin-left:0.125em;margin-right:0.3em;display:inline;content:\"\u2197\";transition:all 0.1s ease-in-out;font-style:normal;}&:hover{&:after{transform:translate(0.15em,-0.2em);}}"], function (props) {
  return props.theme.colors.primary;
}); // Headers

export var H1 = styled.h1.withConfig({
  displayName: "SharedStyledComponents__H1",
  componentId: "sc-1cr9zfr-14"
})(["", ""], Mixins.textLevel1);
export var H2 = styled.h2.withConfig({
  displayName: "SharedStyledComponents__H2",
  componentId: "sc-1cr9zfr-15"
})(["", ""], Mixins.textLevel2);
export var H3 = styled.h3.withConfig({
  displayName: "SharedStyledComponents__H3",
  componentId: "sc-1cr9zfr-16"
})(["", ""], Mixins.textLevel3);
export var H4 = styled.h4.withConfig({
  displayName: "SharedStyledComponents__H4",
  componentId: "sc-1cr9zfr-17"
})(["", ""], Mixins.textLevel4);
export var H5 = styled.h5.withConfig({
  displayName: "SharedStyledComponents__H5",
  componentId: "sc-1cr9zfr-18"
})(["", ""], Mixins.textLevel5);
export var CardContainer = styled.div.withConfig({
  displayName: "SharedStyledComponents__CardContainer",
  componentId: "sc-1cr9zfr-19"
})(["display:flex;flex-wrap:wrap;margin-left:-1rem;margin-right:-1rem;"]);
export var CardGrid = styled.div.withConfig({
  displayName: "SharedStyledComponents__CardGrid",
  componentId: "sc-1cr9zfr-20"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(min(100%,280px),1fr));gap:2rem;"]);
export var StyledCard = styled(Card).withConfig({
  displayName: "SharedStyledComponents__StyledCard",
  componentId: "sc-1cr9zfr-21"
})(["margin:1rem;padding:1.5rem;flex:1 0 30%;min-width:280px;max-width:31%;@media (max-width:", "){max-width:46%;}@media (max-width:", "){max-width:100%;}"], function (props) {
  return props.theme.breakpoints.l;
}, function (props) {
  return props.theme.breakpoints.m;
});
export var StyledCardMaxWidth = styled(StyledCard).withConfig({
  displayName: "SharedStyledComponents__StyledCardMaxWidth",
  componentId: "sc-1cr9zfr-22"
})(["max-width:420px;"]); // Buttons

var Button = styled.button.withConfig({
  displayName: "SharedStyledComponents__Button",
  componentId: "sc-1cr9zfr-23"
})(["text-decoration:none;display:inline-block;white-space:nowrap;margin-top:0.5rem;padding:0.5rem 0.75rem;font-size:1rem;border-radius:0.25em;text-align:center;cursor:pointer;&:disabled{opacity:0.4;cursor:not-allowed;}"]);
export var ButtonPrimary = styled(Button).withConfig({
  displayName: "SharedStyledComponents__ButtonPrimary",
  componentId: "sc-1cr9zfr-24"
})(["background-color:", ";color:", ";border:1px solid transparent;&:hover{background-color:", ";}&:active{background-color:", ";}"], function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.buttonColor;
}, function (props) {
  return props.theme.colors.primaryHover;
}, function (props) {
  return props.theme.colors.primaryActive;
});
export var ButtonSecondary = styled(Button).withConfig({
  displayName: "SharedStyledComponents__ButtonSecondary",
  componentId: "sc-1cr9zfr-25"
})(["background-color:transparent;color:", ";border:1px solid ", ";&:hover{color:", ";border:1px solid ", ";}&:active{background-color:", ";}"], function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.secondaryButtonBackgroundActive;
});
export var Eth2Header = styled.h2.withConfig({
  displayName: "SharedStyledComponents__Eth2Header",
  componentId: "sc-1cr9zfr-26"
})(["font-style:normal;font-weight:normal;font-weight:800;font-size:48px;line-height:120%;max-width:640px;margin-bottom:0rem;color:", ";@media (max-width:", "){font-size:40px;}"], function (props) {
  return props.theme.colors.text00;
}, function (props) {
  return props.theme.breakpoints.l;
});
export var Eth2HeaderGradient = styled.span.withConfig({
  displayName: "SharedStyledComponents__Eth2HeaderGradient",
  componentId: "sc-1cr9zfr-27"
})(["background-clip:text;background-image:", ";-webkit-background-clip:text;-webkit-text-fill-color:transparent;@media (max-width:", "){display:inline-block;}"], function (props) {
  return props.theme.colors.eth2Gradient;
}, function (props) {
  return props.theme.breakpoints.s;
}); // MDX components

export var Paragraph = styled.p.withConfig({
  displayName: "SharedStyledComponents__Paragraph",
  componentId: "sc-1cr9zfr-28"
})(["font-size:1rem;margin:2rem 0 1rem;color:", ";"], function (props) {
  return props.theme.colors.text300;
});
export var Header1 = styled.h1.withConfig({
  displayName: "SharedStyledComponents__Header1",
  componentId: "sc-1cr9zfr-29"
})(["", " font-weight:700;@media (max-width:", "){font-size:2.5rem;}&:before{content:\"\";display:block;height:140px;margin-top:-140px;visibility:hidden;}a{display:none;}"], Mixins.textLevel1, function (props) {
  return props.theme.breakpoints.m;
});
export var Header2 = styled.h2.withConfig({
  displayName: "SharedStyledComponents__Header2",
  componentId: "sc-1cr9zfr-30"
})(["", " position:inherit !important;font-weight:700;&:before{content:\"\";display:block;height:120px;margin-top:-120px;visibility:hidden;}a.header-anchor{position:relative;display:none;margin-left:-1.5em;padding-right:0.5rem;font-size:1rem;vertical-align:middle;&:hover{display:initial;fill:", ";}}&:hover{a.header-anchor{display:initial;fill:", ";}}@media (max-width:", "){font-size:1.25rem;}"], Mixins.textLevel2, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.breakpoints.m;
});
export var Header3 = styled.h3.withConfig({
  displayName: "SharedStyledComponents__Header3",
  componentId: "sc-1cr9zfr-31"
})(["", " font-weight:600;position:inherit !important;&:before{content:\"\";display:block;height:120px;margin-top:-120px;visibility:hidden;}a.header-anchor{position:relative;display:none;margin-left:-1.5em;padding-right:0.5rem;font-size:1rem;vertical-align:middle;&:hover{display:initial;fill:", ";}}&:hover{a.header-anchor{display:initial;fill:", ";}}"], Mixins.textLevel3, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
export var Header4 = styled.h4.withConfig({
  displayName: "SharedStyledComponents__Header4",
  componentId: "sc-1cr9zfr-32"
})(["", " font-weight:600;position:inherit !important;&:before{content:\"\";display:block;height:120px;margin-top:-120px;visibility:hidden;}a{position:relative;display:none;margin-left:-1.5em;padding-right:0.5rem;font-size:1rem;vertical-align:middle;&:hover{display:initial;fill:", ";}}&:hover{a{display:initial;fill:", ";}}"], Mixins.textLevel4, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
export var ListItem = styled.li.withConfig({
  displayName: "SharedStyledComponents__ListItem",
  componentId: "sc-1cr9zfr-33"
})(["color:", ";"], function (props) {
  return props.theme.colors.text300;
}); // Variants (for `framer-motion`)

export var dropdownIconContainerVariant = {
  open: {
    rotate: 0,
    y: 3,
    transition: {
      duration: 0.4
    }
  },
  closed: {
    rotate: -90,
    y: 0
  }
};